export default __webpack_public_path__ + "static/media/news-m.0abdf601.jpg";